<ng-container *ngIf="isLilateAvailable()===true">
    <div class="text-xl font-semibold leading-tight">
        <div class="flex text-xl text-center mt-5">
            <span translate [translateParams]="{language:lilate.language.label}">
                lilate-exam.certif.name.1
            </span>
        </div>
        <div class="flex w-full justify-center mt-5">
            <img class="w-6 h-6 ml-2" src="{{lilate.language.flag}}" alt="language-flag">
        </div>
    </div>
    <div class="font-medium my-5 text-center text-secondary">
        <div translate [translateParams]="{ date: lilate.start | amLocale: 'fr' | amDateFormat:'DD MMMM YYYY' }">
            lilate-exam.session-content.done-date <span *ngIf="lilate.external_organisation_name" translate
                [translateParams]="{ of: lilate.external_organisation_name }">lilate-exam.orga.name.via</span>
        </div>
    </div>

    <hr class="w-full border-t my-6">
    <div class="text-center mb-5" *ngIf="checkIdentidyValidity()==false || lilate.identity_issue">
        <span translate>lilate.download.intro</span>
        <ng-container *ngIf="certification; else attestationSpan">
            <span translate>lilate.download.certificate</span>
        </ng-container>
        <ng-template #attestationSpan>
            <span translate>lilate.download.attestation</span>
        </ng-template>
        <span translate>lilate.download.conclusion</span>
        <ul class="mt-5">
            <li *ngIf="checkIdentidyValidity()==false" translate>lilate.downloadInstructions.photoInvalid</li>
            <li *ngIf="lilate.identity_issue" translate>lilate.downloadInstructions.identityNotValidated</li>
        </ul>
        <div class="mt-5"><span translate>lilate.downloadInstructions.contactSupport</span>
            <a class="underline text-blue-700" href="mailto:lilate@lingueo.com"> lilate&#64;lingueo.com</a>.</div>
    </div>
    <div *ngIf="!lilate.level_global" translate>
        lilate-exam.session-content.isPendingAssessment
    </div>
    <ng-container *ngIf="lilate.is_satisfaction_form_responded; else ElseCertificationButton">
        <ng-container *ngIf="checkIdentidyValidity() && !lilate.identity_issue && birthdateCheck">
            <div class="flex items-center justify-center">
                <button *ngIf="certification" mat-flat-button
                    class="mat-focus-indicator text-green-100 bg-green-500 hover:bg-green-700 mat-flat-button mat-button-base disabled:bg-gray-300 disabled:text-white"
                    (click)="openCertificateLink()"
                    [disabled]="lilate && lilate.level_global.value >= lilate.language.lilate_level && ((lilate.student.user.photo_profile && lilate.student.user.photo_profile.status !== 'validated') || (lilate.identity_issue))"
                    translate>
                    <span translate>
                        lilate-exam.session-content.showcertif
                    </span>
                </button>

                <button mat-flat-button
                    class="mat-focus-indicator text-green-100 bg-green-500 hover:bg-green-700 mat-flat-button mat-button-base disabled:bg-gray-300 disabled:text-white"
                    (click)="downloadLilateLevelAttestationPdf()"
                    *ngIf="!certification && lilate && lilate.level_global.value > 0 && lilate.level_global.value < lilate.language.lilate_level"
                    translate>
                    <span translate>
                        lilate.download.downloadCertificate
                    </span>
                </button>

                <button mat-flat-button
                    class="mat-focus-indicator text-green-100 bg-green-500 hover:bg-green-700 mat-flat-button mat-button-base disabled:bg-gray-300 disabled:text-white"
                    (click)="downloadLilateRealizationCertificatePdf()"
                    *ngIf="!certification && lilate && lilate.level_global.value === 0" translate>
                    <span translate>
                        lilate.download.downloadCertificate
                    </span>
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="!birthdateCheck">
            <div class="flex flex-col gap-4 items-center justify-center ">
                <div translate>lilate.birthdate.card.field.text</div>
                <app-birthdate-input (birthdateChange)="onBirthdateChange($event)"></app-birthdate-input>
            </div>
            <div class="flex items-center justify-center">
                <button mat-flat-button class="mat-focus-indicator text-green-100 bg-green-500 hover:bg-green-700 mat-flat-button mat-button-base disabled:bg-gray-300 disabled:text-white" [disabled]="birthdate.invalid" (click)="updateUser(me.user)"
                    translate>
                    <span translate>
                        lingueopro.onboarding.birthdate.button
                    </span>
                </button>
            </div>
        </ng-container>
    </ng-container>

    <ng-template #ElseCertificationButton>
        <div class="text-center" *ngIf="lilate && lilate.level_global.value >= lilate.language.lilate_level">
            <div class="mb-5" translate>lilate.download.satisfactionSurvey</div>
            <button mat-flat-button
                class="mat-focus-indicator text-green-100 bg-green-500 hover:bg-green-700 mat-flat-button mat-button-base disabled:bg-gray-300 disabled:text-white"
                (click)="showCsatForm()" translate>
                <span translate>
                    lilate.download.accessSurveyButton
                </span>
            </button>
        </div>
        <div class="text-center" *ngIf="lilate && lilate.level_global.value < lilate.language.lilate_level">
            <div class="mb-5" translate>lilate.download.downloadCertificateInfo</div>
            <button mat-flat-button
                class="mat-focus-indicator text-green-100 bg-green-500 hover:bg-green-700 mat-flat-button mat-button-base disabled:bg-gray-300 disabled:text-white"
                (click)="showCsatForm()" translate>
                <span translate>
                    lilate.download.accessSurveyButton
                </span>
            </button>
        </div>
    </ng-template>
</ng-container>

<ng-container *ngIf="isLilateAvailable()===false">
    <div class="font-bold text-2xl" translate>lilate-exam.session-content.isPendingAssessment</div>
</ng-container>